export const pendingInputSampleAction = (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }